import { IDeducoes } from 'interfaces/IDeducao';

export function converterDeducoesParaArrayString(deducoes: IDeducoes | undefined) {
  if (!deducoes) return [];
  const arrayDeStringDeducao: string[] = [];
  deducoes.comprasDeTerceiro.map((ct) => arrayDeStringDeducao.push(ct.nome));
  deducoes.tributosRegulares.map((tr) => arrayDeStringDeducao.push(tr.nome));
  deducoes.tributosEspeciais.map((te) => arrayDeStringDeducao.push(te.nome));
  return arrayDeStringDeducao;
}
